import { queryOptions } from '@tanstack/vue-query'
import { getCurrentUser } from '#shared/api/get-current-user'

export const CURRENT_USER_QUERY_KEY = ['users', 'me'] as const

export const currentUserQueryOptions = queryOptions({
  queryKey: CURRENT_USER_QUERY_KEY,
  queryFn: getCurrentUser,
  staleTime: Infinity,
  gcTime: Infinity,
})
